export type FilterAction =
  | { type: 'set-filter'; key: string; value: string[] }
  | { type: 'reset-filter'; key: string }
  | { type: 'set-filters'; filters: FilterState }
  | { type: 'clear-filters' }

export type FilterState = {
  country: string[]
  opened: string[]
  services: string[]
  brands: string[]
}

export function reducer(state: FilterState, action: FilterAction): FilterState {
  switch (action.type) {
    case 'set-filter':
      return {
        ...state,
        [action.key]: action.value,
      }
    case 'reset-filter':
      return {
        ...state,
        [action.key]: [],
      }

    case 'set-filters':
      return { ...action.filters }
    case 'clear-filters':
      return {
        country: [],
        opened: [],
        services: [],
        brands: [],
      }
    default:
      return state
  }
}
